// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Trash: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13">
            <path
                fill="currentColor"
                d="M19.375,0 L23.125,0 L23.5,0.75 L26.5,0.75 L26.5,2.25 L16,2.25 L16,0.75 L19,0.75 L19.375,0 Z M16.75,3 L25.75,3 L25.75,12 L16.75,12 L16.75,3 Z M19.375,4.5 L18.625,4.5 L18.625,4.875 L18.625,10.125 L18.625,10.5 L19.375,10.5 L19.375,10.125 L19.375,4.875 L19.375,4.5 Z M21.625,4.5 L20.875,4.5 L20.875,4.875 L20.875,10.125 L20.875,10.5 L21.625,10.5 L21.625,10.125 L21.625,4.875 L21.625,4.5 Z M23.875,4.5 L23.125,4.5 L23.125,4.875 L23.125,10.125 L23.125,10.5 L23.875,10.5 L23.875,10.125 L23.875,4.875 L23.875,4.5 Z"
                transform="translate(-16 .5)"
            />
        </svg>
    );
};

export default React.memo(Trash);
